import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { ReportViewCardsNames } from '../../../constans/state';
import { useFilters } from '../../../hooks/useFilters';
import { useReportContext } from '../../../hooks/useReport';
import CardsReports from '../../CardsReports/CardsReports';
import Spinner from '../../Spinner/Spinner';
import { SpinnerCont } from '../ReportLayout.styles';
import { Wrapper } from './EffectReportDetails.styles';
import ReportEffectExternalResults from './ReportEffectExternalResults/ReportEffectExternalResults';
import ReportEffectInsights from './ReportEffectInsights/ReportEffectInsights';
import ReportEffectOpenComments from './ReportEffectOpenComments/ReportEffectOpenComments';
import ReportEffectResources from './ReportEffectResources/ReportEffectResources';
import ReportEffectResults from './ReportEffectResults/ReportEffectResults';

const EffectReportDetails = () => {
  const { getReportDetails, effectData, isLoading, details, openQuestions } = useReportContext();
  const isExternalResults = effectData?.analysis.some(item => item.type === 'EFFECT EXTERNAL');

  const { t } = useTranslation();
  const { currentFilters } = useFilters();
  const { reportId } = useParams();

  const defaultTab = (currentFilters.card as string) || 'results';

  const tabs = [
    { name: t('report.topBar.results'), value: 'results' },
    { name: t('report.topBar.insights'), value: 'insights' },
    ...(isExternalResults
      ? [{ name: t('report.topBar.externalResults'), value: 'externalResults' }]
      : []),
    ...(openQuestions && (openQuestions.external.length || openQuestions.internal.length)
      ? [{ name: t('report.topBar.openComments'), value: 'openComments' }]
      : []),
    // { name: t('report.topBar.resources'), value: 'resources' },
  ];

  const renderContent = useMemo(() => {
    switch (defaultTab) {
      case ReportViewCardsNames.results:
        return <ReportEffectResults />;
      case ReportViewCardsNames.insights:
        return <ReportEffectInsights />;
      case ReportViewCardsNames.externalResults:
        return <ReportEffectExternalResults />;
      case ReportViewCardsNames.openComments:
        return <ReportEffectOpenComments />;
      case ReportViewCardsNames.resources:
        return <ReportEffectResources />;
      default:
        return <ReportEffectResults />;
    }
  }, [defaultTab, details.type]);

  useEffect(() => {
    (async () => {
      await getReportDetails(reportId || '0');
    })();
  }, [reportId]);

  if (!effectData && isLoading) {
    return (
      <SpinnerCont id="SpinnerCont">
        <Spinner size="large" />
      </SpinnerCont>
    );
  }

  return (
    <>
      <CardsReports tabs={tabs} />
      <Wrapper>{renderContent}</Wrapper>
    </>
  );
};

export default EffectReportDetails;
